import { WidgetBase } from '../../widgets';
import { Helper } from '../../common';
import { ReconciliationMeasureWidgetDefinition as definition } from '../../widgets/widgets.definition.index';
import { ReconciliationMeasureConfiguration } from './ReconciliationMeasureConfiguration';

export class ReconciliationMeasureWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: ReconciliationMeasureConfiguration = {
        groupGuid: null
    };
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }
}